export default{
  'VD':[
    'Voltammetry Discrete (VD)',
    'Fit peakHeight - Voltammetry Discrete (VD)',
    'Fit peakPos - Voltammetry Discrete (VD)',
    'Fit peakAUC - Voltammetry Discrete (VD)'
  ],
  'AD':[
    'Amperometry Discrete (AD)',
    'Fit peakHeight - Amperometry Discrete (AD)',
    'Fit peakPos - Amperometry Discrete (AD)',
    'Fit peakAUC - Amperometry Discrete (AD)'
  ],
  'PD':[
    'Potentiometry Discrete (PD)',
    'Fit peakHeight - Potentiometry Discrete (PD)',
    'Fit peakPos - Potentiometry Discrete (PD)',
    'Fit peakAUC - Potentiometry Discrete (PD)'
  ],
  'ID':[
    'Impedance Discrete (ID) Magnitude',
    'Impedance Discrete (ID) Phase',
    'Impedance Discrete (ID) Complex',
    'Circuit Draw',
    'Components Value',
    'Fit Ȳ - Impedance Discrete (ID) Magnitude',
    'Fit Ȳ - Impedance Discrete (ID) Phase',
  ],
  'GD':[
    'Discrete (GD)',
    'Fit peakHeight - Discrete (GD)',
    'Fit peakPos - Discrete (GD)',
    'Fit peakAUC - Discrete (GD)',
    'Discrete (GD) Magnitude',
    'Discrete (GD) Phase',
    'Discrete (GD) Complex',
    'Circuit Draw',
    'Components Value',
    'Fit Ȳ - Discrete (GD) Magnitude',
    'Fit Ȳ - Discrete (GD) Phase',
  ],
  'PC':[
    'Potentiometry Continuous (PC)',
    'Potentiometry Continuous (PC) - Extracted Values',
    'Statistical Evaluation Step Fit',
    'Independent Statistical Evaluation'
  ],
  'AC':[
    'Amperometry Continuous (AC)',
    'Amperometry Continuous (AC) - Extracted Values',
    'Statistical Evaluation Step Fit',
    'Independent Statistical Evaluation'
  ],
  'GC':[
    'Continuous',
    'Statistical Evaluation Step Fit',
    'Independent Statistical Evaluation'
  ]
}